import { AntTag } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type WithTimestamps = {
  created: string
  modified: string
}

type Props = {
  instance: WithTimestamps
}

export const CreatedUpdatedTag: FC<Props> = ({ instance }) => {
  const { t } = useTranslation('bid')
  const formatDate = useFormatDate()
  return (
    <AntTag color="white">
      {t(`dateTag`, {
        created: formatDate(instance.created, { withTime: true }),
        updated: formatDate(instance.modified, { withTime: true }),
      })}
    </AntTag>
  )
}
